<template>
  <v-card
    class="mt-5 pb-4 helmi-card"
    outlined
    elevation="0"
  >
    <v-card-text>
      <div class="helmi-card-title mb-4">
        Kaupan aloittava välittäjä
      </div>
      <v-row>
        <v-col class="py-0">
          Välittäjän nimi: <b class="mr-4 primary--text">
            {{ body.initiatorContactInfo?.firstName }} {{ body.initiatorContactInfo?.lastName }}
          </b><br>
          Välittäjän sähköposti: <b>
            {{ body.initiatorContactInfo?.email }}
          </b><br>
          Välittäjän puhelinnumero: <b>{{ body.initiatorContactInfo?.phoneNumber }}</b><br>
        </v-col>
        <v-btn
          :disabled="locked"
          icon
          class="mr-5"
          @click="editAgentDialog = true"
        >
          <v-icon color="primary">
            create
          </v-icon>
        </v-btn>
      </v-row>
    </v-card-text>

    <v-dialog v-model="editAgentDialog" max-width="500">
      <v-card>
        <v-card-title>Valitse välittäjä</v-card-title>
        <v-card-text class="pb-0">
          <v-select
            v-model="body.initiatorPersonId"
            :items="agents"
            item-text="name"
            item-value="id"
            label="Välittäjä"
            hide-details
            @change="updateInitiator()"
          />
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer/>
          <v-btn
            depressed
            color="primary"
            @click="editAgentDialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import { apiGet } from '../../api';

export default {
  props: {
    body: {
      type: Object,
      default: () => ({
      }),
    },
    locked: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    editAgentDialog: false,
    agents: [],
  }),
  computed: {
    ...mapGetters({
      userDetails: 'userDetails',
    }),
  },
  watch: {
    userDetails: {
      handler(val) {
        if (val) {
          this.getAgents();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getAgents() {
      const agentResponse = await apiGet('agent/getAgents');
      this.agents = agentResponse.result.map(agent => ({
        id: agent.id,
        name: agent.nimi,
        phone: agent.puhelin,
        email: agent.email,
        address: agent.address,
        companyName: agent.companyName,
      }));
      this.body.initiatorPersonId = this.agents.find(a => a.name === this.userDetails.nimi).id;
      this.updateInitiator();
    },
    updateInitiator() {
      const agent = this.agents
        .find(a => +a.id === +this.body.initiatorPersonId);
      const name = agent.name.split(' ');

      this.body.initiatorContactInfo = {
        email: agent.email,
        phoneNumber: agent.phone,
        firstName: name[0],
        lastName: name[name.length - 1],
      };
    },
  },
};
</script>
